import React, { useEffect, useState } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import api from '../api';

const AdminSupport = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [selected, setSelected] = useState(null);

  const fetchMessages = async () => {
    try {
      const { data } = await api.get('/api/contact/messages');
      setMessages(data.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchMessages(); }, []);

  const handleOpen = async (msg) => {
    setSelected(msg);
    if (!msg.is_read) {
      await api.patch(`/api/contact/messages/${msg.id}/read`).catch(() => {});
      setMessages(prev => prev.map(m => m.id === msg.id ? { ...m, is_read: 1 } : m));
    }
  };

  const handleDelete = async (id, e) => {
    e.stopPropagation();
    await api.delete(`/api/contact/messages/${id}`);
    setMessages(prev => prev.filter(m => m.id !== id));
    if (selected?.id === id) setSelected(null);
  };

  const unread = messages.filter(m => !m.is_read).length;

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <main className="admin-main">
        <div className="admin-header">
          <h1>Support {unread > 0 && <span style={{ fontSize: '1rem', background: 'var(--accent)', color: '#fff', borderRadius: 20, padding: '2px 10px', marginLeft: 8 }}>{unread} nouveau{unread > 1 ? 'x' : ''}</span>}</h1>
          <p>Messages reçus depuis la page de contact.</p>
        </div>

        {loading ? (
          <p style={{ color: 'var(--text-muted)' }}>Chargement...</p>
        ) : messages.length === 0 ? (
          <div className="card" style={{ padding: '3rem', textAlign: 'center', color: 'var(--text-muted)' }}>
            Aucun message pour l'instant.
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: selected ? '1fr 1fr' : '1fr', gap: '1.5rem' }}>

            {/* Liste */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '.75rem' }}>
              {messages.map(msg => (
                <div
                  key={msg.id}
                  onClick={() => handleOpen(msg)}
                  className="card"
                  style={{
                    padding: '1.25rem 1.5rem',
                    cursor: 'pointer',
                    borderLeft: `4px solid ${msg.is_read ? '#e0e0e0' : 'var(--accent)'}`,
                    background: selected?.id === msg.id ? '#f9f6f1' : 'white',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >
                  <div style={{ minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem', marginBottom: '.25rem' }}>
                      {!msg.is_read && <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--accent)', flexShrink: 0, display: 'inline-block' }} />}
                      <strong style={{ fontSize: '.95rem' }}>{msg.name}</strong>
                      <span style={{ fontSize: '.8rem', color: 'var(--text-muted)' }}>{msg.email}</span>
                    </div>
                    <div style={{ fontSize: '.85rem', color: 'var(--text-muted)', fontWeight: msg.is_read ? 400 : 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {msg.subject || 'Sans sujet'} — {msg.message.slice(0, 60)}{msg.message.length > 60 ? '…' : ''}
                    </div>
                    <div style={{ fontSize: '.75rem', color: '#aaa', marginTop: '.25rem' }}>
                      {new Date(msg.created_at).toLocaleString('fr-FR')}
                    </div>
                  </div>
                  <button
                    onClick={e => handleDelete(msg.id, e)}
                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#ccc', fontSize: '1.1rem', flexShrink: 0 }}
                    title="Supprimer"
                  >🗑</button>
                </div>
              ))}
            </div>

            {/* Détail */}
            {selected && (
              <div className="card" style={{ padding: '2rem', alignSelf: 'start', position: 'sticky', top: '1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1.5rem' }}>
                  <h2 style={{ fontWeight: 600, fontSize: '1.1rem', margin: 0 }}>{selected.subject || 'Sans sujet'}</h2>
                  <button onClick={() => setSelected(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.2rem', color: '#999' }}>✕</button>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '.5rem', marginBottom: '1.5rem', fontSize: '.9rem' }}>
                  <div><strong>Nom :</strong> {selected.name}</div>
                  <div><strong>Email :</strong> <a href={`mailto:${selected.email}`} style={{ color: 'var(--accent)' }}>{selected.email}</a></div>
                  {selected.phone && <div><strong>Téléphone :</strong> {selected.phone}</div>}
                  <div><strong>Date :</strong> {new Date(selected.created_at).toLocaleString('fr-FR')}</div>
                </div>
                <div style={{ background: '#f9f6f1', borderRadius: 'var(--radius)', padding: '1.25rem', lineHeight: 1.7, fontSize: '.95rem', whiteSpace: 'pre-wrap' }}>
                  {selected.message}
                </div>
                <a
                  href={`mailto:${selected.email}?subject=Re: ${selected.subject || ''}`}
                  className="btn btn-primary"
                  style={{ display: 'inline-block', marginTop: '1.5rem', textDecoration: 'none' }}
                >
                  Répondre par email
                </a>
              </div>
            )}
          </div>
        )}
      </main>
    </div>
  );
};

export default AdminSupport;
